import React from 'react'

export default function RightArrow() {
    return (
        <div>
            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_178_5518)">
                    <path d="M0.13723 0.242577C0.168871 0.326954 4.9677 6.32812 10.8107 13.5844C16.6536 20.8406 21.4208 26.8102 21.4208 26.8629C21.4103 26.9051 16.6325 32.9484 10.8001 40.2785C4.9677 47.6086 0.168871 53.673 0.13723 53.7469C0.0950429 53.8734 0.928246 53.8945 5.40012 53.8945H10.7052L21.4103 40.4367C27.2954 33.0328 32.1154 26.9156 32.1154 26.8418C32.1154 26.7574 27.2954 20.7141 21.4103 13.4051L10.7052 0.105469H5.40012C0.98098 0.105469 0.0950429 0.12656 0.13723 0.242577Z" fill="#BB0600" />
                    <path d="M21.8537 0.20034C21.8642 0.253075 26.6736 6.2437 32.5271 13.521C38.3806 20.7878 43.1689 26.7785 43.1689 26.8417C43.1689 26.8945 38.3806 32.9695 32.5271 40.3207C26.6736 47.6824 21.8642 53.7468 21.8537 53.7996C21.8326 53.8628 23.8998 53.8839 27.1693 53.8734L32.5166 53.8417L43.0529 40.6054C48.8537 33.3281 53.6841 27.2425 53.7896 27.0949L53.99 26.8207L43.2533 13.4894L32.5166 0.15815L27.1693 0.126511C23.9209 0.115963 21.8326 0.137058 21.8537 0.20034Z" fill="#BB0600" />
                </g>
                <defs>
                    <clipPath id="clip0_178_5518">
                        <rect width="54" height="54" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}
